/* MENASA: no newsletter popup on the storefront (user decision, 3 October 2026).
   The Klaviyo app embed stays on: its tracking and any form placed in a page keep working. Only Klaviyo's popup and
   flyout sign-up forms, and the "Sign up" teaser tab that reopens them, are suppressed. They are never painted; one
   that opens is closed at once through its own close button, so Klaviyo records it as dismissed. Klaviyo locks the
   page scroll while a popup is open (body.klaviyo-prevent-body-scrolling) and releases it at the end of a close
   animation that never runs here, so the lock is released whenever no Klaviyo dialog is genuinely on screen.
   To show the popup again, remove this script's tag from layout/theme.liquid (or switch the form off in Klaviyo,
   Sign-up forms, and keep this file as it is). */
(() => {
  if (window.menasaNoPopups) return;
  window.menasaNoPopups = true;
  const POPUPS = 'div[role="dialog"][aria-label="POPUP Form"],div[role="dialog"][aria-label="FLYOUT Form"]';
  const LOCK = 'klaviyo-prevent-body-scrolling';
  const style = document.createElement('style');
  style.textContent = POPUPS + ',[class*="kl-teaser-"]{display:none!important}';
  document.head.append(style);
  const settle = () => {
    for (const dialog of document.querySelectorAll(POPUPS)) {
      const button = dialog.querySelector('.klaviyo-close-form');
      if (!button || 'menasaClosed' in dialog.dataset) continue;
      dialog.dataset.menasaClosed = '';
      button.click();
    }
    if (!document.body.classList.contains(LOCK)) return;
    // Another Klaviyo dialog (not one of these) keeps its own lock.
    const open = [...document.querySelectorAll('[data-kl-scroll-locking-modal]')].some(d => !d.matches(POPUPS));
    if (!open) document.body.classList.remove(LOCK);
  };
  // Klaviyo announces its forms (klaviyoForms, type "open"); the observers are the fallback.
  addEventListener('klaviyoForms', e => { if (e.detail && e.detail.type === 'open') requestAnimationFrame(settle); });
  new MutationObserver(() => { if (document.querySelector(POPUPS) || document.body.classList.contains(LOCK)) settle(); }).observe(document.body, { childList: true, subtree: true });
  new MutationObserver(settle).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  settle();
})();
